import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'

import {
  IconDependencyTree,
  IconGrid
} from '@contrast-security-inc/design-system-foundations'

const IconWrapper = ({ iconName, size, color }) => {
  const icons = {
    IconDependencyTree,
    IconGrid
  }
  const IconName = icons[iconName]
  return <IconName size={size} color={color} />
}

export const reactIconWrapper = createNgReactBridgeDirective(
  'reactIconWrapper',
  [],
  IconWrapper,
  ['iconName', 'size', 'color']
)
